import React, { useEffect, useRef, useState } from "react";
import { Grid, TextField, FormControl, Autocomplete, InputAdornment  } from "@mui/material";
import { createExpedient } from "../services/expediente.service";
import { obtenerTiposDeTramite } from "../services/tipoTramite.service";
import moment from "moment-timezone";
import { USERID, DESTINOS } from "../config/constants"
import { notification } from "antd";
import { COLORS } from "../config/theme";
import ButtonComponent from "../components/ButtonComponent";
import "./ExpedienteForm.css";
import CustomTextarea from "./CustomTextarea";


export const ExpedienteForm = ({  
    setIsVisibleModal,
    setReload,
    reload}) => {
  const [procedureData, setProcedureData] = useState({
        id_estado: 1,
        alta_fec: moment().format("YYYY-MM-DD"),
        id_tramite: "",
        id_oficina_actual: "",
    });
    
  // eslint-disable-next-line no-unused-vars
  const [tipoTramiteList, setTipoTramiteList] = useState([]);
  const [destinosList, setDestinoslList] = useState(DESTINOS)

  // eslint-disable-next-line no-unused-vars
  const autocompleteRef = useRef(null);
  const inputRef = useRef(null);
  const [inputValue, setInputValue] = useState("");

  
  useEffect(() => {
    if (!window.google || !window.google.maps) {
      console.error("Google Maps JavaScript API script not loaded");
      return;
    }
    const autocomplete = new window.google.maps.places.Autocomplete(
      inputRef.current,
      {
        types: ["address"],
      }
    );
    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();
      if (place && place.geometry) {
        const address = place.formatted_address;
        const position = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        };

        setInputValue(address);

        const country = place.address_components.find((component) =>
          component.types.includes("country")
        );
        const locality = place.address_components.find((component) =>
          component.types.includes("locality")
        );
        const administrative_area_level_2 = place.address_components.find(
          (component) => component.types.includes("administrative_area_level_2")
        );
        const administrative_area_level_1 = place.address_components.find(
          (component) => component.types.includes("administrative_area_level_1")
        );
        const codePostal = place.address_components.find((component) =>
          component.types.includes("postal_code")
        );

        const addressNew = place.address_components.find((component) =>
          component.types.includes("route")
        );
        const numberAddress = place.address_components.find((component) =>
          component.types.includes("street_number")
        );

        const pais = country?.long_name || "";
        const localidad = locality?.long_name || "";
        const municipio = administrative_area_level_2?.long_name || "";
        const codigoPostal = codePostal?.long_name || "";
        const provincia = administrative_area_level_1?.long_name || "";
        const calle = addressNew?.long_name || "";
        const numero = numberAddress?.long_name || "";

        setProcedureData((procedureData) => ({
          ...procedureData,
          dir_calle: calle,
          dir_nro: numero,
          dir_loc: localidad,
          pais: pais,
          municipio: municipio,
          codigoPostal: codigoPostal,
          provincia: provincia,
          lat: position.lat,
          lng: position.lng,
        }));
      }
    });

    autocompleteRef.current = autocomplete;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputValue]);

  useEffect(() => {
    loadTiposDeTramite();
  }, [reload]);

  const loadTiposDeTramite = () => {
    obtenerTiposDeTramite()
      .then((results) => {
        setTipoTramiteList(results.data);
      })
      .catch((error) => {
        console.log("Error obteniendo tipo de tramite", error);
      });
  };

  const handleInputChange = (event, name) => {
    const value = event.target ? event.target.value : event;
    setProcedureData((procedureData) => ({
      ...procedureData,
      [name]: value,
    }));
  };

  const handleTipoDeTramiteChange = (event, value) => {
    console.log("value change", value);
    setProcedureData((procedureData) => ({
      ...procedureData,
      "id_tramite": value ? value.id : null, "id_oficina_actual": value.id_oficina_inicia
    }));
  }

  const handleDestinoChange = (e, value) => {
    // Convierte los valores seleccionados a una cadena separada por comas
    const concatenatedValues = value.map((item) => item.id).join(",");
  
    // Aquí puedes almacenar los valores concatenados en el estado o enviarlos a la base de datos
    setProcedureData({
      ...procedureData,
      destino: concatenatedValues, // Guarda los valores concatenados
    });
  };


  const handleSubmit = async () => {
    const idUser = localStorage.getItem(USERID);
    const errors = [];

    // Validaciones requeridas
    if (!procedureData.id_tramite) errors.push("Debe seleccionar un tipo de trámite.");
    if (!procedureData.dir_calle) errors.push("Debe ingresar una calle.");
    if (!procedureData.dir_nro) errors.push("Debe ingresar un número.");
    if (!procedureData.dir_loc) errors.push("Debe ingresar una localidad.");
    if (!procedureData.destino || procedureData.destino.trim() === "") errors.push("Debe seleccionar al menos un destino.");

    if (errors.length > 0) {
      notification["error"]({
        message: "Campos requeridos faltantes",
        description: (
          <ul style={{ margin: 0, paddingLeft: "20px" }}>
            {errors.map((err, idx) => (
              <li key={idx}>{err}</li>
            ))}
          </ul>
        ),
      });
      return;
    }

    // Alta del usuario
    procedureData.alta_us = idUser;

    try {
      const response = await createExpedient(procedureData);
      if (response.data) {
        notification["success"]({
          message: response?.data?.message || "Expediente creado exitosamente",
        });
        setIsVisibleModal(false);
        setReload(!reload);
      }
    } catch (error) {
      console.log("error al crear expediente", error);
      notification["error"]({
        message: error?.response?.data?.message || "Error al crear el expediente",
      });
      setIsVisibleModal(false);
      setReload(!reload);
    }
};


  const cancel = () => {
    setIsVisibleModal(false);
    setReload(!reload);
  };

  return (
    <>
        <div className="abmContainerNew">
            <Grid container spacing={2}>
            {/* TIPO EXPEDIENTE */}
            <Grid item xs={12}>
                <FormControl fullWidth>
                <Autocomplete
                    size="small"
                    options={tipoTramiteList}
                    getOptionLabel={(option) => option.descripcion}
                    value={
                    tipoTramiteList.find(
                        (item) => item.id === parseInt(procedureData.id_tramite)
                    ) || null
                    }
                    onChange={(e, value) => {
                      handleTipoDeTramiteChange(e, value)
                    // handleAutocompleteChange(e, value, "id_tramite");
                    }}
                    renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Tipo"
                        variant="outlined"
                    />
                    )}
                />
                </FormControl>
            </Grid>
            {/* PLANO ANTECEDENTE */}
            <Grid item xs={8}>
                <TextField
                label="Plano antecedente"
                size="small"
                name="plano_antecedente"
                value={procedureData.plano_antecedente || ""}
                onChange={(e) => handleInputChange(e, "plano_antecedente")}
                fullWidth
                
                />
            </Grid>  
            <Grid item xs={4}></Grid>          
            {/* NOMENCLATURA */}
            {/* Circunscripción */}
            <Grid item xs={3}>
              <FormControl fullWidth>
                <Autocomplete
                  size="small"
                  options={["I", "II", "III", "IV", "V"]}
                  getOptionLabel={(option) => option}
                  value={procedureData.circ || ""}
                  onChange={(e, value) => handleInputChange({ target: { value } }, "circ")}
                  renderInput={(params) => (
                    <TextField {...params} label="Circunscripción" variant="outlined" />
                  )}
                />
              </FormControl>
            </Grid>

            {/* Sección */}
            <Grid item xs={3}>
              <TextField
                label="Sección"
                size="small"
                name="secc"
                value={procedureData.secc || ""}
                onChange={(e) => handleInputChange(e, "secc")}
                onKeyDown={(e) => {
                  const regex = /^[A-Za-z]$/;
                  if (!regex.test(e.key) && e.key !== "Backspace" && e.key !== "Tab") {
                    e.preventDefault(); // Bloquea cualquier entrada no válida
                  }
                }}
                inputProps={{ maxLength: 1 }}
                fullWidth
              />
            </Grid>

            {/* Fracción */}
            <Grid item xs={3}>
              <TextField
                label="Fracción Nº"
                size="small"
                name="fr_nro"
                value={procedureData.fr_nro || ""}
                onChange={(e) => handleInputChange(e, "fr_nro")}
                onKeyDown={(e) => {
                  const regex = /^[0-9]$/;
                  if (!regex.test(e.key) && e.key !== "Backspace" && e.key !== "Tab") {
                    e.preventDefault(); // Bloquea cualquier entrada no válida
                  }
                }}
                inputProps={{ maxLength: 3 }}
                fullWidth
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                label="Fracción Letra"
                size="small"
                name="fr_lt"
                value={procedureData.fr_lt || ""}
                onChange={(e) => handleInputChange(e, "fr_lt")}
                onKeyDown={(e) => {
                  const regex = /^[A-Za-z]$/;
                  if (!regex.test(e.key) && e.key !== "Backspace" && e.key !== "Tab") {
                    e.preventDefault(); // Bloquea cualquier entrada no válida
                  }
                }}
                inputProps={{ maxLength: 3 }}
                fullWidth
              />
            </Grid>

            {/* Quinta */}
            <Grid item xs={3}>
              <TextField
                label="Quinta Nº"
                size="small"
                name="q_nro"
                value={procedureData.q_nro || ""}
                onChange={(e) => handleInputChange(e, "q_nro")}
                onKeyDown={(e) => {
                  const regex = /^[0-9]$/;
                  if (!regex.test(e.key) && e.key !== "Backspace" && e.key !== "Tab") {
                    e.preventDefault(); // Bloquea cualquier entrada no válida
                  }
                }}
                inputProps={{ maxLength: 3 }}
                fullWidth
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                label="Quinta Letra"
                size="small"
                name="q_lt"
                value={procedureData.q_lt || ""}
                onChange={(e) => handleInputChange(e, "q_lt")}
                onKeyDown={(e) => {
                  const regex = /^[A-Za-z]$/;
                  if (!regex.test(e.key) && e.key !== "Backspace" && e.key !== "Tab") {
                    e.preventDefault(); // Bloquea cualquier entrada no válida
                  }
                }}
                inputProps={{ maxLength: 3 }}
                fullWidth
              />
            </Grid>

            {/* Chacra */}
            <Grid item xs={3}>
              <TextField
                label="Chacra Nº"
                size="small"
                name="ch_nro"
                value={procedureData.ch_nro || ""}
                onChange={(e) => handleInputChange(e, "ch_nro")}
                onKeyDown={(e) => {
                  const regex = /^[0-9]$/;
                  if (!regex.test(e.key) && e.key !== "Backspace" && e.key !== "Tab") {
                    e.preventDefault(); // Bloquea cualquier entrada no válida
                  }
                }}
                inputProps={{ maxLength: 3 }}
                fullWidth
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                label="Chacra Letra"
                size="small"
                name="ch_lt"
                value={procedureData.ch_lt || ""}
                onChange={(e) => handleInputChange(e, "ch_lt")}
                onKeyDown={(e) => {
                  const regex = /^[A-Za-z]$/;
                  if (!regex.test(e.key) && e.key !== "Backspace" && e.key !== "Tab") {
                    e.preventDefault(); // Bloquea cualquier entrada no válida
                  }
                }}
                inputProps={{ maxLength: 3 }}
                fullWidth
              />
            </Grid>

            {/* Manzana */}
            <Grid item xs={3}>
              <TextField
                label="Manzana Nº"
                size="small"
                name="mz_nro"
                value={procedureData.mz_nro || ""}
                onChange={(e) => handleInputChange(e, "mz_nro")}
                onKeyDown={(e) => {
                  const regex = /^[0-9]$/;
                  if (!regex.test(e.key) && e.key !== "Backspace" && e.key !== "Tab") {
                    e.preventDefault(); // Bloquea cualquier entrada no válida
                  }
                }}
                inputProps={{ maxLength: 3 }}
                fullWidth
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                label="Manzana Letra"
                size="small"
                name="mz_lt"
                value={procedureData.mz_lt || ""}
                onChange={(e) => handleInputChange(e, "mz_lt")}
                onKeyDown={(e) => {
                  const regex = /^[A-Za-z]$/;
                  if (!regex.test(e.key) && e.key !== "Backspace" && e.key !== "Tab") {
                    e.preventDefault(); // Bloquea cualquier entrada no válida
                  }
                }}
                inputProps={{ maxLength: 3 }}
                fullWidth
              />
            </Grid>

            {/* Parcela */}
            <Grid item xs={3}>
              <TextField
                label="Parcela Nº"
                size="small"
                name="p_nro"
                value={procedureData.p_nro || ""}
                onChange={(e) => handleInputChange(e, "p_nro")}
                onKeyDown={(e) => {
                  const regex = /^[0-9]$/;
                  if (!regex.test(e.key) && e.key !== "Backspace" && e.key !== "Tab") {
                    e.preventDefault(); // Bloquea cualquier entrada no válida
                  }
                }}
                inputProps={{ maxLength: 3 }}
                fullWidth
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                label="Parcela Letra"
                size="small"
                name="p_lt"
                value={procedureData.p_lt || ""}
                onChange={(e) => handleInputChange(e, "p_lt")}
                onKeyDown={(e) => {
                  const regex = /^[A-Za-z]$/;
                  if (!regex.test(e.key) && e.key !== "Backspace" && e.key !== "Tab") {
                    e.preventDefault(); // Bloquea cualquier entrada no válida
                  }
                }}
                inputProps={{ maxLength: 3 }}
                fullWidth
              />
            </Grid>

            {/* Sub Parcela */}
            <Grid item xs={3}>
              <TextField
                label="Sub Parcela Nº"
                size="small"
                name="sp_nro"
                value={procedureData.sp_nro || ""}
                onChange={(e) => handleInputChange(e, "sp_nro")}
                onKeyDown={(e) => {
                  const regex = /^[0-9]$/;
                  if (!regex.test(e.key) && e.key !== "Backspace" && e.key !== "Tab") {
                    e.preventDefault(); // Bloquea cualquier entrada no válida
                  }
                }}
                inputProps={{ maxLength: 3 }}
                fullWidth
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                label="Sub Parcela Letra"
                size="small"
                name="sp_lt"
                value={procedureData.sp_lt || ""}
                onChange={(e) => handleInputChange(e, "sp_lt")}
                onKeyDown={(e) => {
                  const regex = /^[A-Za-z]$/;
                  if (!regex.test(e.key) && e.key !== "Backspace" && e.key !== "Tab") {
                    e.preventDefault(); // Bloquea cualquier entrada no válida
                  }
                }}
                inputProps={{ maxLength: 3 }}
                fullWidth
              />
            </Grid>

            {/* PARTIDA */}
            <Grid item xs={6}>
                <TextField
                label="Partida"
                size="small"
                name="partida"
                value={procedureData.partida || ""}
                onChange={(e) => handleInputChange(e, "partida")}
                fullWidth
                
                />
            </Grid>
            {/* DOMICILIO */}
            <Grid item xs={12}>
                <TextField
                label="Domicilio"
                size="small"
                name="dir_calle"
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                inputRef={inputRef}
                fullWidth
                required
                
                />
            </Grid>
            {/* LOCALIDAD */}
            <Grid item xs={6}>
                <TextField
                label="Localidad"
                size="small"
                name="dir_loc"
                value={procedureData.dir_loc || ""}
                onChange={(e) => handleInputChange(e, "dir_loc")}
                fullWidth
                disabled={true}
                />
            </Grid>
            {/* ZONIFICACIÓN */}
            <Grid item xs={6}>
                <TextField
                label="Zonificación"
                size="small"
                name="zonificacion"
                value={procedureData.zonificacion || ""}
                onChange={(e) => handleInputChange(e, "zonificacion")}
                fullWidth
                
                />
            </Grid>
            {/* SUPERFICIE DE PARCELA */}
            <Grid item xs={4}>
                <TextField
                label="Sup. Parcela"
                size="small"
                name="superficie_parcela"
                value={procedureData.superficie_parcela || ""}
                onChange={(e) => handleInputChange(e, "superficie_parcela")}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      m²
                    </InputAdornment>
                  ),
                }}
                fullWidth
                
                />
            </Grid>
            {/* FOS */}
            <Grid item xs={2}>
                <TextField
                label="FOS"
                size="small"
                name="fos"
                value={procedureData.fos || ""}
                onChange={(e) => handleInputChange(e, "fos")}
                fullWidth
                // InputProps={{
                //   startAdornment: (
                //     <InputAdornment position="start">
                //       %
                //     </InputAdornment>
                //   ),
                // }}
                
                />
            </Grid>
            {/* FOT */}
            <Grid item xs={2}>
                <TextField
                label="FOT"
                size="small"
                name="fot"
                value={procedureData.fot || ""}
                onChange={(e) => handleInputChange(e, "fot")}
                fullWidth
                // InputProps={{
                //   startAdornment: (
                //     <InputAdornment position="start">
                //       %
                //     </InputAdornment>
                //   ),
                // }}
                
                />
            </Grid>
            {/* CANTIDAD */}
            {/* <Grid item xs={4}>
                <TextField
                label="Cantidad"
                size="small"
                name="cant_uf"
                value={procedureData.cant_uf || ""}
                onChange={(e) => handleInputChange(e, "cant_uf")}
                fullWidth
                
                />
            </Grid> */}
            {/* DESTINO */}
            <Grid item xs={12}>
              <FormControl fullWidth>
                <Autocomplete
                  multiple
                  size="small"
                  options={destinosList}
                  name="destino"
                  getOptionLabel={(option) => option.value}
                  value={destinosList.filter((item) =>
                    procedureData.destino?.split(",").includes(item.id.toString())
                  )} // Muestra los valores seleccionados
                  onChange={(e, value) => handleDestinoChange(e, value)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Destino"
                      variant="outlined"
                    />
                  )}
                />
              </FormControl>
            </Grid>            
            {/* OBSERVACIONES */}
            <Grid item xs={12}>
              <CustomTextarea
                  rows={4}
                  disabled={false}
                  value={procedureData.obs || ""}
                  onChange={(e) => handleInputChange(e, "obs")}
                  label="Observaciones"
                />
            </Grid>                
            </Grid>    
            <Grid
                container
                spacing={1}
                style={{
                justifyContent: "flex-end",
                }}
            >
                <Grid
                item
                xs={12}
                xl={2}
                lg={2}
                style={{
                    display: "flex",
                    gap: "8px",
                    justifyContent: "flex-end",
                }}
                >
                <ButtonComponent
                    name={"Guardar"}
                    color={COLORS.SECONDARY}
                    toAction={handleSubmit}
                />
                <ButtonComponent
                    name={"Cancelar"}
                    color={COLORS.DANGER}
                    toAction={cancel}
                />
                </Grid>
            </Grid>
        </div>
    </>
  );
};